import * as React from 'react';
import { Containers } from '@grandvisionhq/stores-v2';

const StoreSearchForm = Containers.StoreSearchForm;
const StoreFinderSearchForm = ({ labels , appointmentTypeId , storeQueryFilter ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "appointments-store-finder-search-form"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "appointments-store-finder-search-form__title h4"
    }, labels.title), /*#__PURE__*/ React.createElement(StoreSearchForm, {
        appointmentTypeId: appointmentTypeId,
        storeQueryFilter: storeQueryFilter
    }))
;
var StoreFinderSearchForm$1 = StoreFinderSearchForm;

export { StoreFinderSearchForm$1 as default };
//# sourceMappingURL=StoreFinderSearchForm.js.map
